import currency from './../assets/currency';

export const UGX = (value, precision = 0) => currency(value, { seperator: ',', decimal: '.', symbol: 'UGX ', precision });
const cur = (value, decimals = 0) => currency(value, { seperator: ',', decimal: '.', symbol: '', precision: decimals });
export default cur;